var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M47 13.83V57a2.006 2.006 0 0 1-2 2H3a2.006 2.006 0 0 1-2-2V3a2.006 2.006 0 0 1 2-2h31.17c.286-.001.57.06.83.18V11a2.006 2.006 0 0 0 2 2h9.82c.12.26.181.544.18.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M46.82 13h-3c.12.26.181.544.18.83V57a2.006 2.006 0 0 1-2 2h3a2.006 2.006 0 0 0 2-2V13.83c.001-.286-.06-.57-.18-.83zM46.82 13H37a2.006 2.006 0 0 1-2-2V1.18c.22.1.42.24.59.41l10.82 10.82c.17.17.31.37.41.59z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30,
    r: 5,
    fill: "#02a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M24 25a4.966 4.966 0 0 0-1.5.254 4.968 4.968 0 0 1 0 9.492A4.99 4.99 0 1 0 24 25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 5,
    fill: "#02a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M24 6a4.966 4.966 0 0 0-1.5.254 4.968 4.968 0 0 1 0 9.492A4.99 4.99 0 1 0 24 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 49,
    r: 5,
    fill: "#02a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M24 44a4.966 4.966 0 0 0-1.5.254 4.968 4.968 0 0 1 0 9.492A4.99 4.99 0 1 0 24 44z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 5,
    y: 6,
    fill: "#ffdf00",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M14 6h-3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 33,
    y: 25,
    fill: "#ffdf00",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M42 25h-3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h3a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 5,
    y: 44,
    fill: "#ffdf00",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M14 44h-3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h3a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 57a3 3 0 0 0 3 3h42a3 3 0 0 0 3-3V13.828a2.978 2.978 0 0 0-.879-2.121L36.293.879A2.978 2.978 0 0 0 34.172 0H3a3 3 0 0 0-3 3zm44.586-45H37a1 1 0 0 1-1-1V3.414zM2 3a1 1 0 0 1 1-1h31v9a3 3 0 0 0 3 3h9v43a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 55h8a2 2 0 0 0 2-2v-3h2.09A6 6 0 1 0 25 43.09v-7.18A6.008 6.008 0 0 0 29.91 31H32v3a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v3h-2.09A6.008 6.008 0 0 0 25 24.09v-7.18A6 6 0 1 0 18.09 10H16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3h2.09A6.008 6.008 0 0 0 23 16.91v7.18a5.993 5.993 0 0 0 0 11.82v7.18A6.008 6.008 0 0 0 18.09 48H16v-3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm28-29h8v8h-8zM6 15V7h8v8zm14-4a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm0 19a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm4 15a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM6 45h8v8H6z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.68ac27ea9a691696cd81fc9b94f9dd3b.svg";
export { ForwardRef as ReactComponent };